import {createContext} from "preact";
import { FrontendConfig } from '../../src/models/shard-frontend-config'

export const ConfigContext = createContext(new FrontendConfig());